export var widgetUrl = 'https://conversional-production-v3.appspot.com';
